// skipcq: JS-W1028
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function PintPortfolioZeroState() {
  return (
    <Box
      sx={{
        py: 6,
        px: 2,
        textAlign: 'center',
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="h6" component="p" gutterBottom>
        No beers in your portfolio
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Beers listed for your brewery will appear here when they are available.
      </Typography>
    </Box>
  );
}
